import { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Autoplay } from 'swiper/modules';

export default function SliderAside() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState([]);

  async function getBanners() {
    const req = await fetch('https://webapi.ceflix.org/api/banners/aside', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Application-Key': `${process.env.REACT_APP_API}`,
      },
    });
    const res = await req.json();
    if (res.status) {
      setBanners(res.data);
    }
    setLoading(false);
  }

  useEffect(() => {
    getBanners();
  }, []);
  return (
    <div className='px-4 lg:px-0'>
      {!loading && (
        <Swiper
          spaceBetween={10}
          slidesPerView={1}
          modules={[Autoplay]}
          autoplay
          loop
          className="mySwiper w-full p-8 mb-3 mx-6 rounded-md">
          {banners.map((item) => (
            <SwiperSlide key={item.url}>
              <div>
                <LazyLoadImage className="w-full h-full" src={item.url} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
}
